import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
// 登录验证
export default new Vuex.Store({
	state: {
		user: false,
		img1: '',
		routerData: [{
				menuid: 84,
				icon: "li-icon-xiangmuguanli",
				menuname: "会员管理",
				hasThird: null,
				is_display: "1",
				url: "member/member",
				menus: [{
						menuid: 102,
						icon: "icon-order-manage",
						menuname: "会员列表",
						hasThird: "N",

						is_display: "1",
						url: "member/memberList",
						menus: null
					},
					{
						menuid: 104,
						icon: "icon-order-manage",
						menuname: "会员审核",
						hasThird: "N",

						is_display: "1",
						url: "member/member",
						menus: null
					},
				]
			},
			{
				menuid: 4,
				icon: "icon-cs-manage",
				menuname: "公司管理",
				hasThird: null,
				is_display: "1",
				url: "companys/companys",
				menus: [{
						menuid: 34,
						icon: "icon-order-manage",
						menuname: "公司列表",
						hasThird: "N",
						is_display: "1",
						url: "companys/companys",
						menus: null
					},
					{
						menuid: 36,
						icon: "icon-order-manage",
						menuname: "团队列表",
						hasThird: "N",
						is_display: "1",
						url: "group/group",
						menus: null
					},
					{
						menuid: 35,
						icon: "li-icon-shangchengxitongtubiaozitihuayuanwenjian91",
						menuname: "回收站",
						hasThird: "N",
						is_display: "1",
						url: "companys/deleteList",
						menus: null
					}
				]
			},
			{
				menuid: 110,
				icon: "icon-chengshi",
				menuname: "主页",
				hasThird: null,
				is_display: "1",
				url: "homePage",
				menus: null
			},
			{
				menuid: 5,
				icon: "icon-chengshi",
				menuname: "城市管理",
				hasThird: null,
				is_display: "1",
				url: "citys/index",
				menus: null
			},
			{
				menuid: 6,
				icon: "icon-xiaoqu-xianxing",
				menuname: "区域管理",
				hasThird: null,
				is_display: "1",
				url: "district/index",
				menus: null
			},

			{
				menuid: 7,
				icon: "icon-xiaoqu-xianxing",
				menuname: "小区管理",
				hasThird: null,
				is_display: "1",
				if: 0,
				url: "community/community",
				menus: null
			},
			{
				menuid: 85,
				icon: "icon-shenfen",
				menuname: "车库管理",
				hasThird: null,
				is_display: "1",
				url: "garage/index",
				menus: null
			},
			{
				menuid: 86,
				icon: "icon-shenfen",
				menuname: "车位类型",
				hasThird: null,
				is_display: "1",
				url: "carportType/index",
				menus: null
			},
			{
				menuid: 15,
				icon: "icon-shenfen",
				menuname: "合同管理",
				hasThird: null,
				is_display: "1",
				url: "hetong/yingshou",
				menus: [{
						menuid: 1134,
						icon: "icon-order-manage",
						menuname: "财务概览",
						hasThird: "N",

						is_display: "1",
						url: "hetong/yingshou",
						menus: null
					},
					{
						menuid: 1135,
						icon: "icon-order-manage",
						menuname: "合同列表",
						hasThird: "N",

						is_display: "1",
						url: "hetong/hetonglist",
						menus: null
					}
				]
			},
			{
				menuid: 8,
				icon: "icon-shenfen",
				menuname: "身份管理",
				hasThird: null,
				is_display: "1",
				url: "identity/identity",
				menus: [{
						menuid: 50,
						icon: "icon-order-manage",
						menuname: "销售管理",
						hasThird: "N",

						is_display: "1",
						url: "identity/identity",
						menus: null
					},
					{
						menuid: 112,
						icon: "icon-order-manage",
						menuname: "销售文章",
						hasThird: "N",

						is_display: "1",
						url: "identity/enterprise",
						menus: null
					},
					{
						menuid: 51,
						icon: "li-icon-shangchengxitongtubiaozitihuayuanwenjian91",
						menuname: "经理管理",
						hasThird: "N",

						is_display: "1",
						url: "identity/manager",
						menus: null
					},
					{
						menuid: 111,
						icon: "li-icon-shangchengxitongtubiaozitihuayuanwenjian91",
						menuname: "评价标签",
						hasThird: "N",

						is_display: "1",
						url: "identity/personTag",
						menus: null
					},
					{
						menuid: 114,
						icon: "li-icon-shangchengxitongtubiaozitihuayuanwenjian91",
						menuname: "评价管理",
						hasThird: "N",

						is_display: "1",
						url: "identity/evaluate",
						menus: null
					}
				]
			},
			{
				menuid: 81,
				icon: "icon-shenfen",
				menuname: "标签管理",
				hasThird: null,
				is_display: "1",
				url: "label/labelParent",
				menus: [{
						menuid: 82,
						icon: "icon-order-manage",
						menuname: "标签组管理",
						hasThird: "N",

						is_display: "1",
						url: "label/labelParent",
						menus: null
					},
					{
						menuid: 83,
						icon: "icon-order-manage",
						menuname: "子标签管理",
						hasThird: "N",

						is_display: "1",
						url: "label/labelChild",
						menus: null
					}
				]
			},
			{
				menuid: 12,
				icon: "icon-shenfen",
				menuname: "资讯管理",
				hasThird: null,
				is_display: "1",
				url: "information/classify",
				menus: [{
						menuid: 66,
						icon: "icon-order-manage",
						menuname: "分类管理",
						hasThird: "N",

						is_display: "1",
						url: "information/classify",
						menus: null
					},
					{
						menuid: 113,
						icon: "li-icon-shangchengxitongtubiaozitihuayuanwenjian91",
						menuname: "海报管理",
						hasThird: null,

						is_display: "1",
						url: "information/poster",
						menus: null
					}, {
						menuid: 1132,
						icon: "icon-order-manage",
						menuname: "日历海报",
						hasThird: "N",

						is_display: "1",
						url: "information/poster_day",
						menus: null
					},
					{
						menuid: 69,
						icon: "li-icon-shangchengxitongtubiaozitihuayuanwenjian91",
						menuname: "话术管理",
						hasThird: "N",

						is_display: "1",
						url: "information/script",
						menus: null
					},
					{
						menuid: 68,
						icon: "li-icon-shangchengxitongtubiaozitihuayuanwenjian91",
						menuname: "视频管理",
						hasThird: "N",

						is_display: "1",
						url: "information/video",
						menus: null
					},
					{
						menuid: 67,
						icon: "li-icon-shangchengxitongtubiaozitihuayuanwenjian91",
						menuname: "文章管理",
						hasThird: "N",

						is_display: "1",
						url: "information/article",
						menus: null
					},
				]
			},
			{
				menuid: 124,
				icon: "icon-shenfen",
				menuname: "商学院",
				hasThird: null,
				is_display: "1",
				url: "business/artic",
				menus: [{
						menuid: 122,
						icon: "li-icon-xiangmuguanli",
						menuname: "分类管理",
						hasThird: null,
						is_display: "1",
						url: "business/cateGory",
						menus: null
					},
					{
						menuid: 121,
						icon: "li-icon-xiangmuguanli",
						menuname: "文章管理",
						hasThird: null,
						is_display: "1",
						url: "business/artic",
						menus: null
					},
					{
						menuid: 123,
						icon: "li-icon-xiangmuguanli",
						menuname: "视频管理",
						hasThird: null,
						is_display: "1",
						url: "business/video",
						menus: null
					},
				]
			},
			{
				menuid: 125,
				icon: "icon-shenfen",
				menuname: "活动管理",
				hasThird: null,
				is_display: "1",
				url: "",
				menus: [{
					menuid: 1251,
					icon: "li-icon-xiangmuguanli",
					menuname: "开盘大师",
					hasThird: null,
					is_display: "1",
					url: "active/freeParking",
					menus: null
				}, ]
			},
			{
				menuid: 126,
				icon: "icon-shenfen",
				menuname: "电销短信",
				hasThird: null,
				is_display: "1",
				url: "actAICallSms/aiCall",
				menus: [{
					menuid: 1261,
					icon: "li-icon-xiangmuguanli",
					menuname: "AI电销",
					hasThird: null,
					is_display: "1",
					url: "actAICallSms/aiCall",
					menus: null
				}, {
					menuid: 1263,
					icon: "li-icon-xiangmuguanli",
					menuname: "AI电销流程管理",
					hasThird: null,
					is_display: "1",
					url: "actAICallSms/aiFlowSms",
					menus: null
				}, {
					menuid: 1262,
					icon: "li-icon-xiangmuguanli",
					menuname: "促活短信",
					hasThird: null,
					is_display: "1",
					url: "actAICallSms/sms",
					menus: null
				}, {
					menuid: 1264,
					icon: "li-icon-xiangmuguanli",
					menuname: "营销短信",
					hasThird: null,
					is_display: "1",
					url: "actAICallSms/yx_sms",
					menus: null
				}, ]
			},
			{
				menuid: 19,
				icon: "icon-shenfen",
				menuname: "基础管理",
				hasThird: null,
				is_display: "1",
				url: "base/index",
				menus: [{
						menuid: 100,
						icon: "li-icon-xiangmuguanli",
						menuname: "字典管理",
						hasThird: null,
						is_display: "1",
						url: "dict/index",
						menus: null
					},
					{
						menuid: 29,
						icon: "icon-shenfen",
						menuname: "协议管理",
						hasThird: null,
						is_display: "1",
						url: "base/index",
						menus: null
					}
				]
			},
			{
				menuid: 1,
				icon: "li-icon-xiangmuguanli",
				menuname: "权限管理",
				hasThird: null,
				is_display: "1",
				url: "permissions/index",
				menus: [{
						menuid: 103,
						icon: "icon-order-manage",
						menuname: "访问权限",
						hasThird: "N",

						is_display: "1",
						url: "permissions/index",
						menus: null
					},
					{
						menuid: 9,
						icon: "icon-shenfen",
						menuname: "用户管理",
						hasThird: null,
						is_display: "1",
						url: "user/index",
						menus: null
					},
					{
						menuid: 10,
						icon: "icon-shenfen",
						menuname: "角色管理",
						hasThird: null,
						is_display: "1",
						url: "role/index",
						menus: null
					}
				]
			},
			{
				menuid: 13,
				icon: "li-icon-xiangmuguanli",
				menuname: "规则引擎",
				hasThird: null,
				is_display: "1",
				url: "ruleEngine/customerRule",
				menus: [{
						menuid: 14,
						icon: "icon-order-manage",
						menuname: "客户评分规则",
						hasThird: "N",

						is_display: "1",
						url: "ruleEngine/customerRule",
						menus: null
					},
					{
						menuid: 15,
						icon: "icon-shenfen",
						menuname: "客户跟进规则",
						hasThird: null,
						is_display: "1",
						url: "ruleEngine/followRule",
						menus: null
					},
					{
						menuid: 17,
						icon: "icon-shenfen",
						menuname: "客户分配规则",
						hasThird: null,
						is_display: "1",
						url: "ruleEngine/assignmentRule",
						menus: null
					},
					{
						menuid: 16,
						icon: "icon-shenfen",
						menuname: "顾问评分规则",
						hasThird: null,
						is_display: "1",
						url: "ruleEngine/salorRule",
						menus: null
					}
				]
			},
			{
				menuid: 127,
				icon: "li-icon-xiangmuguanli",
				menuname: "费用管理",
				hasThird: null,
				is_display: "1",
				url: "feiyong/index",
				menus: null
			},
		]
	},
	mutations: {
		SET_ROUTER_DATA(state, routerData) {
			state.routerData = routerData;
		},
		setImageUrl(state, url) {
			state.img1 = url;
		},
		// 登录
		login(state, user) {
			state.user = user;
			localStorage.setItem("userInfo", user);
		},
		// 退出
		logout(state, user) {
			state.user = "";
			localStorage.setItem("userInfo", "");
		}
	}
});


// WEBPACK FOOTER //
// ./src/vuex/store.js